import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Box, Typography } from '@mui/material'
import { captureException } from '@sentry/react'

import { layoutForErrorsStyle } from 'common/styles'

interface ErrorContentProps {
  title: string
  statusCode: number
  text: string
}

export default function ErrorContent({ title, statusCode, text }: ErrorContentProps): JSX.Element {
  useEffect(() => {
    captureException(new Error(`${statusCode} ${text}`))
  }, [])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Box sx={layoutForErrorsStyle}>
        <Typography variant="h1">{statusCode}</Typography>
        <Typography mt={1}>{text}</Typography>
      </Box>
    </>
  )
}
